import React from "react"
import RichText from "./richText"
import Form from "./form"

import styles from "./postBody.module.scss"

const PostBody = ({ content, intro, form }) => (
  <div className={styles.postBody}>
    {intro && (
      <section className={styles.postIntro} aria-label="Post intro">
        <RichText blocks={intro} />
      </section>
    )}
    <article className={styles.postContent}>
      <RichText blocks={content} />
    </article>
    {form && form.formLink && (
      <section className={styles.postForm}>
        <Form height="950px" {...form} />
      </section>
    )}
  </div>
)

export default PostBody
